import React, { useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import FundraiserHeader from "../common/FundraiserHeader";
import FundraiserSocial from "./FundraiserSocial";
import FundraiserAboutUs from "./FundraiserAboutUs";
import "./fundraiserbrand.scss";
import SubscriptionPlan from "../common/SubscriptionPlan";
import { useDispatch, useSelector } from "react-redux";
import { getFundraiserContent } from "../../../services/fundraiserService";
import Loader from "../../common/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { getSubscriptionPlans } from "../../../services/subscriptionService";
import { setSelectedPlan } from "../../../redux/slices/subscriptionSlice";
import { getS3PublicUrl } from "../../../utils/s3";

const FundraiserBrandDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.fundraiserReducer?.loading);
  const id = useParams();
  const scrollRef = useRef(null);
  const [content, setContent] = useState();
  const [premiumPlan, setPremiumPlan] = useState({});
  const [basicPlan, setBasicPlan] = useState({});

  const fetchPlans = async () => {
    try {
      const subPlans = await dispatch(getSubscriptionPlans({})).unwrap();
      if (subPlans?.success === true && subPlans?.data?.length > 0) {
        setPremiumPlan(subPlans?.data[0]);
        setBasicPlan(subPlans?.data[1]);
      }
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
    }
  };

  const getContent = async () => {
    const getPromise = await dispatch(
      getFundraiserContent({ userId: id?.id })
    )?.unwrap();
    if (getPromise?.success === true) {
      setContent(getPromise?.data);
    }
  };

  useEffect(() => {
    getContent();
    fetchPlans();
  }, []);

  const scrollTo = () => {
    scrollRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleJoinClick = () => {
    // New flow entry: go straight to new member setup with fundraiser context
    navigate(`/member-setup?fundraiserId=${id?.id}`);
  };

  console.log('content', content);


  return (
    <div className="w-full h-full">
      <Helmet>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`Support ${content?.user?.name} on Swoodle`}
        />
        <meta
          property="og:description"
          content={`Join us in supporting ${content?.user?.name}. Get amazing discounts while contributing to a great cause!`}
        />
        <meta
          property="og:image"
          content={getS3PublicUrl(content?.banner)}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`Support ${content?.user?.name} on Swoodle`}
        />
        <meta
          name="twitter:description"
          content={`Join us in supporting ${content?.user?.name}. Get amazing discounts while contributing to a great cause!`}
        />
        <meta
          name="twitter:image"
          content={getS3PublicUrl(content?.banner)}
        />
      </Helmet>

      {loading === true && <Loader />}
      <FundraiserHeader brandLogo={null} />
      <div className="w-[90%] mx-auto p-6 bg-white">
        <div className="mb-4">
          <h1 className="text-[32px] font-[600] text-[#303030]">
            {content?.user?.name}
          </h1>
        </div>

        <div className="mb-4">
          <img
            src={getS3PublicUrl(content?.logo)}
            alt="East Malvern Knights Logo"
            className="w-[90px] h-[90px] object-contain"
          />
        </div>

        <div className="mb-4 text-[#303030] text-[16px] lg:text-[20px]">
          <p className="font-[400]">
            We are excited to invite you to join us in fundraising for the{" "}
            <span className="text-[#00ADEF] font-[600]">
              {content?.user?.name}!
            </span>
          </p>
          <a
            href={content?.website}
            className="font-[600] hover:underline"
          >
            {content?.website}
          </a>
        </div>

        <div className="mb-4">
          <div
            className="rich-text-content"
            dangerouslySetInnerHTML={{ __html: content?.aboutUs }}
          />
        </div>

        <div className="mb-4">
          <h2 className="font-[600] text-[#303030] text-[16px] lg:text-[20px] mb-3">
            Why We Need Your Support
          </h2>
          <div
            className="rich-text-content"
            dangerouslySetInnerHTML={{ __html: content?.support }}
          />
        </div>

        <p className="text-[#303030] text-[14px] lg:text-[18px] font-[400] mb-6">
          We look forward to working with you
        </p>

        <div className="mb-4">
          <img
            src={getS3PublicUrl(content?.banner)}
            alt="East Malvern Knights Team"
            className="w-full h-[480px] object-cover rounded-lg"
          />
        </div>



        <div className="flex justify-end">
          <button className="bg-[#00ADEF] text-white font-[500] py-2 px-8 rounded-[5px] h-[48px] text-[14px] lg:text-[16px]" onClick={handleJoinClick}>
            Join Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default FundraiserBrandDetails;
